<div class="modal-header customBlueHeader">
  <p class="modal-title">Re-Assign</p>
  <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button> -->
  <button type="button" class="close" aria-label="Close" (click)="modelClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
<div class="modal-body customModalBody">
  <form [formGroup]="reAssignForm" (ngSubmit)="submitReassignData(reAssignForm)">
    <div>
      <!-- open -->
      <div class="form-group">
        <label>Diagnostics Centre Name</label>
        <!-- <select class="form-control col-form-label-sm">
        <option>Select</option>
        <option>...</option>
      </select> -->
        <div>
          <input type="text" formControlName="vendorName" class="form-control col-form-label-sm" id="vendorInfoId"
            list="vendorInfoListIds" (blur)="getPrice()" required />
          <datalist id="vendorInfoListIds">

            <option *ngFor="let vendorObj of vendorInfoList" [ngValue]="vendorObj">{{vendorObj.vendorName}}</option>
          </datalist>
        </div>
        <!-- <div *ngIf="submitted && reAssignForm.controls.vendorName.errors">
      Vendor Name is required
      
  </div> -->

      </div>


      <div class="form-group">
        <label>Test Name</label>
        <select class="form-control col-form-label-sm" formControlName="testName">
          <!-- <option >Select</option> -->
          <option [ngValue]="null" disabled>Select</option>
          <option *ngFor="let testNameObj of testNameList" value={{summary}}>
            {{testNameObj.testName}} - {{testNameObj.netAmount}}

          </option>
        </select>
      </div>

      <div class="form-group">
        <label>Test Price</label>
        <input type="text" class="form-control col-form-label-sm" placeholder="2,500" formControlName="price" required
          readonly>
      </div>
      <!-- <div *ngIf="reAssignForm.controls['price'].errors.required">
      Price is required.
    </div> 
   -->
      <!-- <div *ngIf="submitted && reAssignForm.controls.price.errors">
    Price is required
    
</div> -->

      <div class="form-group">
        <label>Scheduled Date & Time</label>
        <!-- <input type="text" class="form-control col-form-label-sm" placeholder="DD/MM/YYYY"> -->
        <div class="input-group">
          <input class="form-control" (dateSelect)="getSlotData()" [minDate]="minDate" placeholder="yyyy-mm-dd"
            formControlName="selectedDate" name="dp" ngbDatepicker #fD="ngbDatepicker" required>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="fD.toggle()" type="button"><i
                class="fa fa-calendar" aria-hidden="true"></i></button>
          </div>
        </div>
        <div>
          <div><label>Select Slot</label></div>
          <select id="timeDropDown" [(ngModel)]="slotTimingInfo" formControlName="slotTime"
            class="form-control col-form-label-sm">
            <option selected>--Select--</option>
            <option [ngValue]="slotRes" *ngFor="let slotRes of slotResponse">
              {{slotRes.from_time}} - {{slotRes.to_time}}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label>Reason</label>
        <textarea class="form-control col-form-label-sm" formControlName="reason"></textarea>
      </div>

    </div>
    <div class="modal-footer customModalFooter bdr-none">
      <button type="submit" class="btn green_btn">Re Assign</button>
    </div>
  </form>


  <div  *ngIf="labAvailableTimingsRes">
    <p>Available Lab Timings</p>
    <div>

      <table>

        <thead>
          <tr>
            <th>Day</th>
            <th>From Time</th>
            <th>To Time</th>
            <th>EngageMentLevel</th>
          </tr>

        </thead>
        <tbody>
         
       <tr *ngFor="let data of labAvailableTimingsRes.monday">
        <td *ngIf="data">Monday</td>
        <td *ngIf="data">{{data.start_time}}</td> 
        <td *ngIf="data">{{data.end_time}}</td> 
        <td *ngIf="data">{{data.engage_at}}</td> 
      </tr>
      <tr *ngFor="let data of labAvailableTimingsRes.tuesday">
        <td *ngIf="data">Tuesday</td>
        <td *ngIf="data">{{data.start_time}}</td> 
        <td *ngIf="data">{{data.end_time}}</td> 
        <td *ngIf="data">{{data.engage_at}}</td> 
      </tr>
      <tr *ngFor="let data of labAvailableTimingsRes.wednesday">
        <td *ngIf="data">Wednesday</td>
        <td *ngIf="data">{{data.start_time}}</td> 
        <td *ngIf="data">{{data.end_time}}</td> 
        <td *ngIf="data">{{data.engage_at}}</td> 
      </tr>
      <tr *ngFor="let data of labAvailableTimingsRes.thursday">
        <td *ngIf="data">Thursday</td>
        <td *ngIf="data">{{data.start_time}}</td> 
        <td *ngIf="data">{{data.end_time}}</td> 
        <td *ngIf="data">{{data.engage_at}}</td> 
      </tr>
      
      <tr *ngFor="let data of labAvailableTimingsRes.friday">
        <td *ngIf="data">Friday</td>
        <td *ngIf="data">{{data.start_time}}</td> 
        <td *ngIf="data">{{data.end_time}}</td> 
        <td *ngIf="data">{{data.engage_at}}</td> 
      </tr>
      <tr *ngFor="let data of labAvailableTimingsRes.saturday">
        <td *ngIf="data">Saturday</td>
        <td *ngIf="data">{{data.start_time}}</td> 
        <td *ngIf="data">{{data.end_time}}</td> 
        <td *ngIf="data">{{data.engage_at}}</td> 
      </tr>
      <tr *ngFor="let data of labAvailableTimingsRes.sunday">
        <td *ngIf="data">Sunday</td>
        <td *ngIf="data">{{data.start_time}}</td> 
        <td *ngIf="data">{{data.end_time}}</td> 
        <td *ngIf="data">{{data.engage_at}}</td> 
      </tr>
      

      


        </tbody>
      </table>

    </div>

  </div>
</div>